import React from "react";

export default function DagonetStatus({ active }) {
  let statusClass;
  let label;
  if (active === true) {
    statusClass = "active";
    label = "Active";
  } else if (active === false) {
    statusClass = "inactive";
    label = "Inactive";
  } else {
    statusClass = "unknown";
    label = "Unknown";
  }
  return (
    <div className={`status-indicator ${statusClass}`}>
      <span className="dot" />
      <span>{label}</span>
    </div>
  );
}
